var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"mx-0 pa-0",attrs:{"row":""}},[_c('categories',{attrs:{"categories":_vm.categories}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }